import { Record } from "immutable";

export interface IProviaOrderSummaryData {
  orderno: string;
  ponumber: string;
  jobname: string;
  custno: string;
  location: string;
  status: string;
  enterdate: string;
  rcvdate: string;
  shipdate: string;
  dropdate: string;
  invoice: string;
  user1: string;
}

export interface IProviaOrderSummaryRecord extends IProviaOrderSummaryData {}

const defaultProviaOrderSummaryProps: IProviaOrderSummaryRecord = {
  orderno: "",
  ponumber: "",
  jobname: "",
  custno: "",
  location: "",
  status: "",
  enterdate: "",
  rcvdate: "",
  shipdate: "",
  dropdate: "",
  invoice: "",
  user1: "",
};

export class ProviaOrderSummaryRecord
  extends Record(defaultProviaOrderSummaryProps)
  implements IProviaOrderSummaryRecord {}

export const proviaOrderSummaryFromJSON = (json: IProviaOrderSummaryData): ProviaOrderSummaryRecord =>
  new ProviaOrderSummaryRecord({ ...json });
